.step-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 8px;
  background-color: #FFFFFF;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}
.step-card--disabled {
  background-color: #F5F5F5;
}
.step-card--disabled .step-card__content-title {
  color: var(--color-neutral-500);
}
.step-card__icon {
  flex-shrink: 0;
  margin-top: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.step-card__content {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.step-card__content-title {
  font-size: var(--font-size-sm);
  color: var(--color-neutral-700);
  line-height: 1.4;
}
.step-card__divider {
  height: 1px;
  background-color: #E0E0E0;
  margin: 0 8px;
}

.icon--success {
  color: var(--color-feedback-positive-600);
}
.icon--error {
  color: var(--color-feedback-danger-600);
}
.icon--progress {
  color: #2B83F7;
}
.icon--pending {
  color: var(--color-neutral-400);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL3BhZ2VzL0Rhc2hib2FyZC9mcmFnbWVudHMvRGV0YWlsc0dhbnR0L2ZyYWdtZW50cy9OZWdFeGVjdXRpb24vY29tcG9uZW50cy9TdGVwQ2FyZCIsInNvdXJjZXMiOlsiU3RlcENhcmQubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUVBO0VBQ0U7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBOztBQUlKO0VBQ0U7RUFDQTtFQUNBOzs7QUFLRjtFQUNFOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLnN0ZXAtY2FyZCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBmbGV4LXN0YXJ0O1xuICBnYXA6IDEycHg7XG4gIHBhZGRpbmc6IDEycHggOHB4O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjRkZGRkZGO1xuICBib3JkZXItcmFkaXVzOiA0cHg7XG4gIHRyYW5zaXRpb246IGJhY2tncm91bmQtY29sb3IgMC4ycyBlYXNlO1xuXG4gICYtLWRpc2FibGVkIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjRjVGNUY1O1xuICAgIFxuICAgIC5zdGVwLWNhcmRfX2NvbnRlbnQtdGl0bGUge1xuICAgICAgY29sb3I6IHZhcigtLWNvbG9yLW5ldXRyYWwtNTAwKTtcbiAgICB9XG4gIH1cblxuICAmX19pY29uIHtcbiAgICBmbGV4LXNocmluazogMDtcbiAgICBtYXJnaW4tdG9wOiAycHg7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICB9XG5cbiAgJl9fY29udGVudCB7XG4gICAgZmxleDogMTtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG5cbiAgICAmLXRpdGxlIHtcbiAgICAgIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLXNtKTtcbiAgICAgIGNvbG9yOiB2YXIoLS1jb2xvci1uZXV0cmFsLTcwMCk7XG4gICAgICBsaW5lLWhlaWdodDogMS40O1xuICAgIH1cbiAgfVxuXG4gICZfX2RpdmlkZXIge1xuICAgIGhlaWdodDogMXB4O1xuICAgIGJhY2tncm91bmQtY29sb3I6ICNFMEUwRTA7XG4gICAgbWFyZ2luOiAwIDhweDtcbiAgfVxufVxuXG4uaWNvbiB7XG4gICYtLXN1Y2Nlc3Mge1xuICAgIGNvbG9yOiB2YXIoLS1jb2xvci1mZWVkYmFjay1wb3NpdGl2ZS02MDApO1xuICB9XG5cbiAgJi0tZXJyb3Ige1xuICAgIGNvbG9yOiB2YXIoLS1jb2xvci1mZWVkYmFjay1kYW5nZXItNjAwKTtcbiAgfVxuXG4gICYtLXByb2dyZXNzIHtcbiAgICBjb2xvcjogIzJCODNGNztcbiAgfVxuXG4gICYtLXBlbmRpbmcge1xuICAgIGNvbG9yOiB2YXIoLS1jb2xvci1uZXV0cmFsLTQwMCk7XG4gIH1cbn1cbiJdfQ== */